import { render, staticRenderFns } from "./Person.vue?vue&type=template&id=0ef4f10f"
import script from "./Person.vue?vue&type=script&lang=js"
export * from "./Person.vue?vue&type=script&lang=js"
import style0 from "./Person.vue?vue&type=style&index=0&id=0ef4f10f&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef4f10f')) {
      api.createRecord('0ef4f10f', component.options)
    } else {
      api.reload('0ef4f10f', component.options)
    }
    module.hot.accept("./Person.vue?vue&type=template&id=0ef4f10f", function () {
      api.rerender('0ef4f10f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/pricingChange/Person.vue"
export default component.exports